import React from "react"
import { ArrowRight } from "lucide-react"
import { SectionHeading } from "./ui/SectionHeading"

/**
 * Single differentiator item (see data.json → WhyUs)
 */
export interface WhyUsItem {
	icon?: string
	title: string
	text: string
	link?: string
	linkLabel?: string
}

interface WhyUsProps {
	data?: WhyUsItem[]
}

/**
 * WhyUs Component — three verifiable reasons to choose the company.
 * Mirrors the static "#why" section in public/index.html.
 */
export const WhyUs: React.FC<WhyUsProps> = ({ data }) => {
	if (!data || data.length === 0) return null

	return (
		<section id="why" className="lp-section">
			<div className="lp-container">
				<SectionHeading
					eyebrow="Proč my"
					title="Proč B2B Technological Insight"
					lead="Tři ověřitelné důvody, proč s námi firmy pracují – a proč se k nám vracejí s dalšími procesy."
				/>

				<div className="lp-grid lp-grid--3">
					{data.map((item, idx) => (
						<article
							key={item.title}
							className="lp-card lp-card--bar lp-why"
							data-reveal=""
							style={{ "--reveal-delay": `${idx * 100}ms` } as React.CSSProperties}
						>
							<span className="lp-why__num" aria-hidden="true">0{idx + 1}</span>
							<span className="lp-icon-badge" aria-hidden="true">
								{item.icon ? <i className={item.icon} /> : <span>{idx + 1}</span>}
							</span>
							<h3 className="lp-card__title">{idx + 1}. {item.title}</h3>
							<p className="lp-card__text">{item.text}</p>
							{item.link && (
								<a href={item.link} className="lp-why__link">
									{item.linkLabel || "Více informací"} <ArrowRight size={16} />
								</a>
							)}
						</article>
					))}
				</div>
			</div>
		</section>
	)
}
